import { render } from "./LogDetails.vue?vue&type=template&id=c120d5e6&scoped=true"
import script from "./LogDetails.vue?vue&type=script&lang=js"
export * from "./LogDetails.vue?vue&type=script&lang=js"

import "./LogDetails.vue?vue&type=style&index=0&id=c120d5e6&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c120d5e6"]])

export default __exports__